export const extensionRoutes = [  {
    path: 'extensions/product-reviews',
    loadChildren: () => import('./extensions/43787b3448e31a7ba2b1e3bdeaf43a70586d14e8130278efca1c90964d3ef984/routes'),
  }];
